import dayjs from 'dayjs';
import ReactMarkdown from 'react-markdown';

import ChatbotIcon from '#/assets/svgs/ChatbotIcon.svg';
import { CHATBOT_ROLE, DATE_FORMAT } from '#/utils/constants';

function ChatMessages({ messages, color, textColor, chatBotImage, reactions, handleReaction, isSending }) {
  return (
    <>
      {messages.map(({ text, created, role, id, reaction }) => (
        <div
          key={id || `${role}-${created}`}
          className={`message ${role === CHATBOT_ROLE.USER ? 'sender' : 'receiver'}`}
        >
          {role !== CHATBOT_ROLE.USER && (
            <div className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</div>
          )}
          <div className="text-wrapper">
            {role === CHATBOT_ROLE.USER ? (
              <p style={{ backgroundColor: color, color: textColor }}>{text}</p>
            ) : (
              <div className="markdown-content">
                <ReactMarkdown
                  components={{
                    a: ({ node, ...props }) => <a {...props} target="_blank" />,
                  }}
                >
                  {text}
                </ReactMarkdown>
              </div>
            )}
            <div className="date-reactions">
              <span>{`${role === CHATBOT_ROLE.ASSISTANT ? 'Livechat' : ''} ${dayjs(created).format(DATE_FORMAT.STANDARD_TIME)}`}</span>
              {role === CHATBOT_ROLE.ASSISTANT && reactions?.data?.results?.length > 0 && (
                <div className="reactions">
                  {reactions.data.results.map(({ id: emojiId, emoji }) => (
                    <span
                      key={emojiId}
                      onClick={handleReaction(id, text, emojiId, reaction)}
                      className={emojiId === reaction ? 'active' : ''}
                    >
                      <img src={emoji} alt="emoji" />
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {isSending && (
        <div className="message receiver loading-dots">
          <div className="image">{chatBotImage ? <img src={chatBotImage} alt="Chatbot" /> : <ChatbotIcon />}</div>
          <p>
            <span className="dots">
              <span className="dot" />
              <span className="dot" />
              <span className="dot" />
            </span>
          </p>
        </div>
      )}
    </>
  );
}

export default ChatMessages;
